export default "__VITE_ASSET__LEcnBVA9__"